import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';

const MAXIMUM_FETCH_COUNT = 100;

interface IGetNegativeCriterionUrlProps {
  customerId: string;
  accountId: string;
  campaignId: string;
  isAdGroupCriterion?: boolean;
}

export interface IFetchNegativeCriterionDataProps extends IGetNegativeCriterionUrlProps {
  ccToken: string;
}

const AdGroupCriterionSelectParams = {
  $top: MAXIMUM_FETCH_COUNT,
  $count: 'true',
  $select: 'Criterion,Id,AdGroupId,LevelOfDetails',
  $expand: 'Campaign,AdGroup',
};

const CampaignCriterionSelectParams = {
  $top: MAXIMUM_FETCH_COUNT,
  $count: 'true',
  $select: 'Criterion,Id',
  $expand: 'Campaign',
};

export function getNegativeCampaignCriterionURL({
  customerId,
  accountId,
  campaignId,
}: IGetNegativeCriterionUrlProps) {
  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/CampaignCriterions/Model.NegativeCampaignCriterion`;
}

export function getNegativeAdGroupCriterionURL({
  customerId,
  accountId,
  campaignId,
}: IGetNegativeCriterionUrlProps) {
  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/AdGroupCriterions/Model.NegativeAdGroupCriterion`;
}

export function fetchExclusionReportData({
  accountId,
  customerId,
  campaignId,
  isAdGroupCriterion = true,
  ccToken,
}: IFetchNegativeCriterionDataProps) {
  const url = isAdGroupCriterion ? getNegativeAdGroupCriterionURL({customerId, accountId, campaignId}) : getNegativeCampaignCriterionURL({customerId, accountId, campaignId});
  const params = isAdGroupCriterion ? AdGroupCriterionSelectParams : CampaignCriterionSelectParams;

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
    params,
  } as AxiosRequestConfig);
}
